:host {
  display: inline-grid;
}

div {
  display: contents;
}